var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 37C23.0293 37 19 32.9707 19 28C19 23.0293 23.0293 19 28 19C32.9707 19 37 23.0293 37 28C37 32.9707 32.9707 37 28 37ZM28 35.2C29.9096 35.2 31.7409 34.4414 33.0912 33.0912C34.4414 31.7409 35.2 29.9096 35.2 28C35.2 26.0904 34.4414 24.2591 33.0912 22.9088C31.7409 21.5586 29.9096 20.8 28 20.8C26.0904 20.8 24.2591 21.5586 22.9088 22.9088C21.5586 24.2591 20.8 26.0904 20.8 28C20.8 29.9096 21.5586 31.7409 22.9088 33.0912C24.2591 34.4414 26.0904 35.2 28 35.2ZM27.1 23.5H28.9V25.3H27.1V23.5ZM27.1 27.1H28.9V32.5H27.1V27.1Z",
    fill: "#E8AA4E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#FFFAEB",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.e0693d7c5573e9478821378eac724684.svg";
export { ForwardRef as ReactComponent };